import { useQuery } from '@tanstack/react-query';
import PlatformService from '@lwolf-common/platform-service/build/PlatformService';
import {
    getEndpoint,
    PLATFORM_DOMAIN,
    PLATFORM_LOCAL_LAUNCH
} from '../../providers/endpoint.provider';
import { appIdByAppName } from '../../constants/app';
import { runningApp } from '../../constants/app';

export function usePlatformService(enabled = true) {
    const result = useQuery({
        queryKey: ['platformService'],
        queryFn: () =>
            PlatformService.initialize({
                lwDomain: getEndpoint(PLATFORM_DOMAIN),
                appId: appIdByAppName[runningApp],
                lwaOnly: true,
                luParamSupplier: () => getEndpoint(PLATFORM_LOCAL_LAUNCH),
                logRocket: {
                    enabled: true,
                    suppressInternalUsers: false
                }
            }),
        enabled, // This flag runs the query only when true
        staleTime: Infinity,
        cacheTime: Infinity,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        retry: 3
    });

    return result;
}
